import { z } from "zod";
export var DmaCalculationState;
(function (DmaCalculationState) {
    DmaCalculationState["Canceled"] = "Canceled";
    DmaCalculationState["Failed"] = "Failed";
    DmaCalculationState["Running"] = "Running";
    DmaCalculationState["Succeeded"] = "Succeeded";
    DmaCalculationState["Waiting"] = "Waiting";
})(DmaCalculationState || (DmaCalculationState = {}));
export const dmaCalculationStateDtoSchema = z.nativeEnum(DmaCalculationState);
